import React from 'react';
import { Badge } from '@/components/ui';
import { formatNavCount } from './awaitingApprovalsCount';

interface NavCountBadgeProps {
  count: number;
}

/**
 * Compact pending-count pill for the dark navbar and the light Approvals dropdown.
 * Hidden when there is nothing waiting so the menu does not show a zero.
 */
const NavCountBadge: React.FC<NavCountBadgeProps> = ({ count }) => {
  if (count <= 0) return null;
  return (
    <Badge
      bg="warning"
      pill
      aria-hidden="true"
      className="tw-min-w-[1.15rem] tw-px-1.5 tw-py-0.5 tw-text-center tw-text-[0.65rem] tw-leading-none tw-tabular-nums"
    >
      {formatNavCount(count)}
    </Badge>
  );
};

export default NavCountBadge;
